module.exports = __webpack_public_path__ + "img/视频场景_短视频.03196882.png";